import React from "react";
import "./BannerStyle.scss";
import { bannerTextContent } from "./constant/index";
import { DotButton, useDotButton } from "../Common_UI_Kit/EmblaDotButton";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import AutoScroll from "embla-carousel-auto-scroll";

const BannerSection = ({ bannerTitleText, bannerParaText, bannerImageSrcContact, bannerImageSrc }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      slidesToScroll: "auto",
      align: "start",
      loop: true,
    },
    [Autoplay({ playOnInit: true, delay: 3000, stopOnInteraction: false })]
    // [AutoScroll({ playOnInit: true, stopOnInteraction: false })]
  );

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  return (
    <section className="banner-section">
      <div className="banner-wrap">
        <div className="embla">
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              {bannerTextContent.content.map((item, index) => (
                <div className="embla__slide" key={index}>
                  <div className="banner-box">
                    <div className="text-box">
                      <h1 className="title-text">{bannerTitleText || item.titleText}</h1>
                      <p className="para-text">{bannerParaText || item.paraText}</p>
                      <a href="#" className="contact-img-box">
                        <img src={bannerImageSrcContact || item.imageSrcContact} alt="Image" />
                      </a>
                    </div>

                    <div className="img-box">
                      <img src={bannerImageSrc || item.imageSrc} alt="Image" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="embla-dots-box">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={"embla__dot".concat(
                  index === selectedIndex ? " embla__dot--selected" : ""
                )}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
